// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Users__container__ouO1T{display:flex;flex-direction:column;height:100%;min-height:0%}.Users__container__ouO1T .Users__userList__uB97u{overflow-y:scroll;height:100%}
`, "",{"version":3,"sources":["webpack://./src/js/apps/part11/containers/Users/Users.scss"],"names":[],"mappings":"AAAA,yBACI,YAAa,CACb,qBAAsB,CACtB,WAAY,CACZ,aAAc,CAJlB,iDAOQ,iBAAkB,CAClB,WAAY","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    min-height: 0%;\n\n    .userList {\n        overflow-y: scroll;\n        height: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Users__container__ouO1T`,
	"userList": `Users__userList__uB97u`
};
export default ___CSS_LOADER_EXPORT___;
